<template lang="pug">
div
  div.text-sm.font-medium.neutral700--text Underlying conditions
  v-card.round-xl.mt-2(outlined)
    v-simple-table.table-custom(dense)
      thead
        tr
          th.text-xs.font-medium.neutral500--text(style="text-transform: none !important;") Condition
          th.text-xs.font-medium.neutral500--text(style="text-transform: none !important;") Remarks
          th.text-xs.font-medium.neutral500--text(style="text-transform: none !important;" width="80")
      tbody
        template(v-for="(item, idx) in selectedItems")
          tr(:key="`cnd-${idx}`" style="height: 60px;")
            td
              underlying-conditions-dropdown(v-if="item.editable" v-model="item.name" :error="false")
              div.text-xs.font-medium.neutral700--text(v-else) {{ item.name }}
            td
              v-text-field.text-sm.round-xl(v-if="item.editable" v-model="item.remarks" placeholder="Enter remarks" outlined dense height="40" hide-details="auto")
              div.text-xs.font-medium.neutral700--text(v-else) {{ item.remarks || '-' }}
            td.text-xs.neutral700--text.text-end.pr-4.pl-0
              y-button.mr-2(outlined color="neutral400" background-color="var(--v-neutral100)" prepend-icon="$yzi-trash-03" icon-color="danger500" icon-size="16" unset-min-width size="xxs" height="24" button-class="px-1" @click="removeItem(idx)")
              y-button(outlined color="neutral400" background-color="var(--v-neutral100)" prepend-icon="$yzi-edit-02" icon-color="neutral700" icon-size="16" unset-min-width size="xxs" height="24" button-class="px-1" :disabled="item.editable" @click="item.editable = true")
  y-button.mt-4(label="Add more" outlined color="neutral400" prepend-icon="$yzi-plus" icon-size="16" icon-color="neutral500" text-color="neutral700" size="xs" height="28" unset-min-width button-class="px-2" @click="addItem")
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import UnderlyingConditionsDropdown from '@/components/clinic/consultation/UnderlyingConditionsDropdown.vue'

export default {
  components: { UnderlyingConditionsDropdown },
  props: {
    items: {
      type: Array,
      default: () => []
    },
  },
  data: () => ({}),
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    showDialog: {
      get () {
        return this.open 
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
    selectedItems: {
      get () {
        return this.items
      },
      set (newValue) {
        this.$emit('update:items', newValue)
      }
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    addItem () {
      this.selectedItems.push({ name: null, remarks: null, editable: true })
    },
    removeItem (index) {
      this.selectedItems.splice(index, 1)
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .table-custom {
    .text-table-header, .v-data-table__wrapper > table > thead > tr > th {
      background-color: var(--v-neutral200);
      &:first-child {
        border-top-left-radius: 10px;
      }
      &:last-child {
        border-top-right-radius: 10px;
      }
    }
  }
}
</style>